<!-- ordinal of fifty to allow the page to have buttons to the left -->
<div adaptToolbarContent
     [ordinal]="50">
    <button class="dx-datagrid-export-button"
            adaptButtonIcon="dx-icon dx-icon-xlsxfile"
            adaptTooltip="Export all data"
            (click)="exportAllData()"
            data-test="export-data-button"></button>
    <button adaptButtonIcon="dx-icon dx-icon-column-chooser"
            adaptTooltip="Column chooser"
            (click)="showColumnChooser()"></button>
    <button adaptButtonIcon="dx-icon dx-icon-revert"
            adaptTooltip="Reset columns"
            (click)="resetGridState()"></button>
</div>

<dx-data-grid *adaptLoading="isLoading"
              class="people-grid-component"
              [dataSource]="gridData"
              [stateStoring]="gridHelper.stateStoringOptions"
              [columns]="gridColumns"
              [columnAutoWidth]="true"
              [allowColumnResizing]="true"
              [allowColumnReordering]="true"
              [rowAlternationEnabled]="true"
              [hoverStateEnabled]="true"
              [showRowLines]="true"
              [showBorders]="true"
              [noDataText]="stakeholderView ? 'No Stakeholders have been added to this organisation' : 'No data'"
              (onInitialized)="onGridInitialized($event)">
    <dxo-data-grid-filter-row [visible]="true"></dxo-data-grid-filter-row>
    <dxo-data-grid-header-filter [visible]="true"></dxo-data-grid-header-filter>
    <dxo-data-grid-paging [pageSize]="25"></dxo-data-grid-paging>
    <dxo-data-grid-pager [showPageSizeSelector]="true"
                         [allowedPageSizes]="[10, 25, 50, 100, 250]"></dxo-data-grid-pager>
    <dxo-data-grid-column-chooser [enabled]="false"></dxo-data-grid-column-chooser>
    <dxo-data-grid-scrolling [useNative]="true"></dxo-data-grid-scrolling>

    <dxo-data-grid-summary>
        <dxi-data-grid-group-item summaryType="count"
                                  name="connectionTypeCountSummary"
                                  showInColumn="People"></dxi-data-grid-group-item>
        <dxi-data-grid-total-item displayFormat="Total People: {0}"
                                  column="People"
                                  summaryType="count"> </dxi-data-grid-total-item>
    </dxo-data-grid-summary>

    <div *dxTemplate="let item of 'connectionTypeTemplate'">{{ item.value }} ({{ getConnectionTypeSummaryCount(item) }})</div>

    <adapt-link-person *dxTemplate="let item of 'fullNameCellTemplate'"
                       [showImage]="true"
                       imageSize="sm"
                       [person]="item.data.person"></adapt-link-person>

    <ul *dxTemplate="let item of 'culturalLeadersTemplate'">
        @for (relationship of item.data.culturalLeaders; track relationship) {
            <li>
                <adapt-link-person [person]="relationship.culturalLeader"></adapt-link-person>
                @if (relationship.isSupporting) {
                    <span [adaptTooltip]="SupportingMemberTooltip"
                          class="fal fa-circle fa-xs supporting-icon p-2"></span>
                }
            </li>
        }
    </ul>

    <ul *dxTemplate="let item of 'roleCellTemplate'">
        @for (roleConnection of item.data.roleConnections; track roleConnection) {
            <li>
                <adapt-link-role [role]="roleConnection.role"></adapt-link-role>
            </li>
        }
    </ul>

    <ul *dxTemplate="let item of 'teamCellTemplate'">
        @for (team of item.data.teams; track team) {
            <li>
                <adapt-link-team [team]="team"
                                 [focusPersonId]="item.data.person.personId"></adapt-link-team>
            </li>
        }
    </ul>

    <ul *dxTemplate="let item of 'contactDetailCellTemplate'">
        @for (detail of item.data.contactDetails[item.column.caption]; track detail) {
            <li>
                <adapt-contact-detail [detail]="detail"
                                      [showIcon]="false"></adapt-contact-detail>
            </li>
        }
    </ul>
</dx-data-grid>
